package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class CommunityAdministratorCandidateDTO(
    val userId: String,
    val displayName: String,
    val email: String,
    val assigned: Boolean,
    val assignedAt: String? = null
)

@Serializable
data class AssignCommunityAdministratorRequest(
    val userId: String
)

@Serializable
data class AdminContextDTO(
    val platformAdmin: Boolean,
    val communityAdmin: Boolean,
    val managedCommunityIds: List<String>
)
